import React from 'react';
import PropTypes from 'prop-types';
import PriceSpan from './PriceSpan';

type DiscountPriceSpanProps = {
  pricedArticle: any;
  fontSize: 'lg' | 'sm';
};

export default function DiscountPriceSpan({
  pricedArticle,
  fontSize,
}: DiscountPriceSpanProps) {
  const { displayDiscount } = pricedArticle;

  return (
    <>
      <PriceSpan pricedArticle={pricedArticle} fontSize={fontSize} />

      {displayDiscount > 0 && (
        <span className="text-nowrap badge bg-danger py-1">
          -{displayDiscount}%
        </span>
      )}
    </>
  );
}

DiscountPriceSpan.propTypes = {
  pricedArticle: PropTypes.object.isRequired,
  fontSize: PropTypes.oneOf(['lg', 'sm']),
};

DiscountPriceSpan.defaultProps = {
  fontSize: 'sm',
};
